import { createPermission } from '@backstage/plugin-permission-common';

export const pulseManagementReadPermission = createPermission({
  name: 'pulse.management.read',
  attributes: { action: 'read' },
});

export const pulseProjectCreatePermission = createPermission({
  name: 'pulse.project.create',
  attributes: { action: 'create' },
});

export const pulsePermissions = {
  pulseManagementReadPermission,
  pulseProjectCreatePermission,
};
